import axios from "../http";

class Temporary {
  //劳务公司列表
  getTempLaborList(warehouseId) {
    const url = `/zwy/api/pc/temp/labor/list?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //临时工信息
  getTempList(warehouseId, laborId, date, name, currentPage) {
    const url = `/zwy/api/pc/temp/salary/list?warehouseId=${warehouseId}&laborId=${laborId}&date=${date}&name=${name}&currentPage=${currentPage}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //更新临时工信息
  postUpdateTemp(data) {
    const url = `/zwy/api/pc/temp/salary/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //规则制定
  postUpdateTempLabor(data) {
    const url = `/zwy/api/pc/temp/labor/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //移动
  postMoveTemp(data) {
    const url = `/zwy/api/pc/temp/labor/move`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //重新计算
  postTempCalculate(data) {
    const url = `/zwy/api/pc/temp/calculate`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导出
  getExportExcel(warehouseId, laborId, date, name) {
    const url = `/zwy/api/download/temp/salary?warehouseId=${warehouseId}&laborId=${laborId}&date=${date}&name=${name}`;
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default Temporary;
